import { render, staticRenderFns } from "./ContactEditAddressEmailSettings.vue?vue&type=template&id=21cbb8cb&scoped=true"
import script from "./ContactEditAddressEmailSettings.vue?vue&type=script&lang=ts"
export * from "./ContactEditAddressEmailSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cbb8cb",
  null
  
)

export default component.exports